var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CircularProgress, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
// import { createPermalink, getPermalinkAPINew } from './chitraSlice';
import { createPermalink } from './chitraSlice';
import { IframeUrl } from './url';
var PermalinkForm = function () {
    var location = useLocation();
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.chitra; }), permalink = _a.permalink, isLoadingGetPermalink = _a.isLoadingGetPermalink, isLoadingChitraTokenBackend = _a.isLoadingChitraTokenBackend;
    var loading = isLoadingGetPermalink === 'loading' || isLoadingChitraTokenBackend === 'loading';
    var chitra_token = localStorage.getItem("CHITRA_TOKEN");
    var chitra_csrf_token = localStorage.getItem("CSRF_TOKEN");
    var queryParams = new URLSearchParams(location.search);
    var dashboardIdFromUrl = queryParams.get("Id");
    var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedMenu, parsedMenu, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 8, , 9]);
                    if (!(chitra_token && chitra_csrf_token)) return [3 /*break*/, 6];
                    selectedMenu = localStorage.getItem("SELECTED_SUB_MENU");
                    if (!selectedMenu) return [3 /*break*/, 4];
                    parsedMenu = JSON.parse(selectedMenu);
                    if (!(parsedMenu !== null && parsedMenu !== void 0 && parsedMenu.DisplayName)) return [3 /*break*/, 2];
                    // await dispatch(getPermalinkAPINew({ dashboardName: parsedMenu?.DisplayName, token : chitra_token }))
                    return [4 /*yield*/, dispatch(createPermalink({
                            dashboardId: Number(dashboardIdFromUrl),
                            token: chitra_token,
                            csrfToken: chitra_csrf_token
                        }))];
                case 1:
                    // await dispatch(getPermalinkAPINew({ dashboardName: parsedMenu?.DisplayName, token : chitra_token }))
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    console.log("Menu does not have a DisplayName.");
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    console.log("No menu selected.");
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    console.error('Token generation failed. Contact your Administrator.');
                    _a.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_1 = _a.sent();
                    console.error('Error during initialization:', error_1);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var initializePermalink = function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                initialize();
                return [2 /*return*/];
            });
        }); };
        initializePermalink();
    }, [location.search, chitra_token]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 0
    }, loading ? /*#__PURE__*/ React.createElement(CircularProgress, {
        style: {
            margin: '20px auto',
            marginTop: '30%',
            display: 'block'
        }
    }) : /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        id: "reports-container",
        style: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden',
            padding: 0,
            marginTop: 0,
            minHeight: "100vh",
            marginLeft: '0px',
            justifyContent: 'flex-start'
        }
    }, permalink ? /*#__PURE__*/ React.createElement("embed", {
        id: "test",
        style: {
            height: '100%',
            width: '100%'
        },
        src: IframeUrl(permalink !== null && permalink !== void 0 ? permalink : '')
    }) : null)));
};
export default PermalinkForm;
